/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleGroupAssignmentUpdate
 */
export interface VehicleGroupAssignmentUpdate {
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignmentUpdate
     */
    vehicleGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignmentUpdate
     */
    vehicleId?: string | null;
}

/**
 * Check if a given object implements the VehicleGroupAssignmentUpdate interface.
 */
export function instanceOfVehicleGroupAssignmentUpdate(value: object): value is VehicleGroupAssignmentUpdate {
    return true;
}

export function VehicleGroupAssignmentUpdateFromJSON(json: any): VehicleGroupAssignmentUpdate {
    return VehicleGroupAssignmentUpdateFromJSONTyped(json, false);
}

export function VehicleGroupAssignmentUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleGroupAssignmentUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleGroupId': json['vehicleGroupId'] == null ? undefined : json['vehicleGroupId'],
        'vehicleId': json['vehicleId'] == null ? undefined : json['vehicleId'],
    };
}

export function VehicleGroupAssignmentUpdateToJSON(json: any): VehicleGroupAssignmentUpdate {
    return VehicleGroupAssignmentUpdateToJSONTyped(json, false);
}

export function VehicleGroupAssignmentUpdateToJSONTyped(value?: VehicleGroupAssignmentUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleGroupId': value['vehicleGroupId'],
        'vehicleId': value['vehicleId'],
    };
}

